import _ from 'lodash';
import React from 'react';
import { CarouselTablet, Margin, Padding, Text } from '../../components';
import {
  LifeAtGlossierComponent,
  lifeAtGlossierData,
  lifeAtGlossierImages,
} from './shared';

export const LifeAtGlossierTablet = () => {
  return (
    <Margin size={[7, 0, 7, 0]}>
      <CarouselTablet images={lifeAtGlossierImages} duration={0}>
        {_.flow((lifeAtGlossierData) =>
          _.map(lifeAtGlossierData, (value, index) => {
            return (
              <div key={index}>
                <Padding size={[6, 4]}>
                  <Text align="left" textType="heading3">
                    Life at Glossier
                  </Text>
                </Padding>
                <LifeAtGlossierComponent value={value} />
              </div>
            );
          })
        )(lifeAtGlossierData)}
      </CarouselTablet>
    </Margin>
  );
};
